import { gql } from '@apollo/client'

export const FETCH_BUNDLE_HISTORY = gql`
  query BundleHistory($bundleId: ID!) {
    bundleHistory(bundleId: $bundleId) {
      edges {
        node {
          user {
            id
            firstName
            lastName
            email
          }
          createdAt
          resourcableType
          resourcableId
          category
          alters
        }
      }
    }
  }
`
